import React, {useEffect, useMemo, useState} from 'react'
import { useForm } from 'react-hook-form'

import styles from './EvtInternalTest.module.css'
import {useParams} from "react-router";
import {OrgState, setOrg, useOrgState} from "../../slices/orgSlice";
import {useAutoEvt} from "../../queries/useAutoEvt";
import axios from "axios";
import download from 'downloadjs';
import {Button} from "@material-ui/core";

type FormData = {
  eventspaymentprocessorkey: string;
}
interface Params {
  eventid: string
}

const EvtInternalTest = ({ isEdit = false }) => {
    const { eventid } = useParams<Params>()
    useAutoEvt(eventid)
    const orgState = useOrgState()
    const formMethods = useForm<FormData>()
    const { reset, watch, setValue } = formMethods

    const generatePDF = async (eventid, exportType) => {
        const {data} = await axios.post('/evtinternaltest', {eventid: eventid, type: exportType}, {responseType: "blob"})
        return data
    }
    const generatePDFClick = async () => {
        const resendData = await generatePDF(Number(eventid), 'PDF')
        if (resendData) {
            download(resendData, 'InternalTest.pdf', 'application/pdf');
        }
    }

    const generateExcelClick = async () => {
        const resendData = await generatePDF(Number(eventid), 'EXCEL')
        if (resendData) {
            download(resendData, 'InternalTest.xls', 'application/xls');
        }
    }

    return (
        <div className={styles.root}>
            <Button variant="contained"
                    color="primary"
                    onClick={() => { generateExcelClick() }}>Excel</Button>
            <Button variant="contained"
                    color="primary"
                    onClick={() => { generatePDFClick() }}>Pdf</Button>
        </div>
    )
}

export default EvtInternalTest
